import { createApp } from 'vue'
import YegaBootstrap from '../components/yega/bootstrap'
import Multiselect from 'vue-multiselect'

export function mountApplication(component, element, options = {}) {
  const app = createApp(component)
  const router = options.router || component.router
  const store = options.store || component.store
  if (store) app.use(store)
  if (router) app.use(router)
  app.use(YegaBootstrap)
  app.component('multiselect', Multiselect)
  // Existing domain mixins use these setters. Vue 3 proxies track assignment.
  app.config.globalProperties.$set = (target, key, value) => (target[key] = value)
  app.config.globalProperties.$delete = (target, key) => delete target[key]
  app.mount(element)
  return app
}
